/** The error code the server put in its envelope (`{msg: {errorCode}}`), if any. */
export function errorCodeOf(err: any): string {
  return (err && err.msg && err.msg.errorCode) || '';
}
